import React from 'react';
import { Text, TextStyle } from 'react-native';
import { TypographyProps } from './TextProps';
import { themes, typeVariants } from '../../theme/theme';

const Typography: React.FC<TypographyProps> = ({
  children,
  variant = 'body1',
  style,
  ...props
}) => {
  const textStyle = { ...(typeVariants[variant] as TextStyle), color: themes.light.gray_blue[1] };

  return (
    <Text style={[textStyle, style]} {...props}>
      {children}
    </Text>
  );
};

export default Typography;
